export const SERVICE_CATALOG_CODE = {
  acceptCaregiverProfileFillMyInfo: 'HH_FILL_MY_INFO_ACCEPT_CG',
  acceptFamilyProfile: 'HH_ACCEPT_FF',
  activitiesAndEvents: 'HH_ACTEVNT',
  addCaregiver: 'HH_ADD_CG',
  addCaregiverFillMyInfo: 'HH_FILL_MY_INFO_ADD_CG',
  addChildren: 'HH_ADD_CHILD',
  addFamilyAndFriends: 'HH_ADD_FF',
  addFamilyAndFriendsFillMyInfo: 'HH_FILL_MY_INFO_ADD_FF',
  admissions: 'HH_ADM',
  allergies: 'ALG',
  appointments: 'APM',
  approveCaregiver: 'HH_APPROVE_CG',
  autoPaySetup: 'HH_AUTOPAY',
  bedside: 'BEDSIDE',
  birthInformation: 'HH_BIRTH',
  cancelCaregiverRequest: 'HH_CANCEL_CG',
  cancelFamilyRequest: 'HH_CANCEL_FF',
  careCircle: 'HH_CARECIRCLE',
  careCompanion: 'CARECOM',
  careJourney: 'CAREJRNY',
  carePal: 'FLEXI_PUB_CAREPAL',
  carePlans: 'CAREPLAN',
  caregiver: 'HH_CG',
  chas: 'CHA',
  chatAssistant: 'HH_CA',
  consentForSchoolHealthAndDentalServices: 'HH_CSHD',
  derom: 'HH_DEROM',
  directoryOfServices: 'HH_DOS',
  dischargeSummary: 'HH_DIS',
  documentsAndMc: 'DOC',
  education: 'EDU',
  emergencyVisit: 'HH_EMGVST',
  explore: 'HH_EXPLORE',
  financialConsents: 'HH_FINCON',
  geneticReports: 'HH_GENREP',
  growthCharts: 'HH_GRWTH',
  healthFeed: 'HEALTHFEED',
  healthHub: 'HH',
  healthBuddyProfile: 'HH_HB_PROFILE',
  healthIssues: 'HEALTHISS',
  healthProfiles: 'HH_PROFILES',
  healthReports: 'HEALTHREP',
  healthRiskAssessment: 'HH_HRA',
  healthScreening: 'HSC',
  healthTogether: 'HEALTHTGT',
  healthUp: 'HEALTHUP',
  healthierSg: 'HSG',
  healthierSgAppointments: 'HSG_APPT',
  healthierSgHealthPlan: 'HH_HSG_HP',
  healthierSgScreening: 'HH_SFL',
  heartTrack: 'HRTTRK',
  histologyAndCytologyReports: 'HH_HISTO',
  home: 'HH_HOME',
  immunisationRecords: 'IMR',
  inbox: 'HH_INBOX',
  labReports: 'LBR',
  letters: 'LTR',
  livechat: 'HH_LC',
  makeNewAppointment: 'APM/CREATE',
  medicalAlertAndAdverseDrugReactionDrugAllergy: 'MAD',
  medicalReportsCertificatesRequests: 'MRC',
  medicationRefill: 'MRF',
  medicationRefillHistory: 'MRH',
  medications: 'MED',
  messages: 'MSG',
  milestones: 'HH_MLST',
  moveVid: 'MVID',
  myProfile: 'HH_PROFILE',
  nehrAccessHistory: 'HH_NEHRAH',
  nehrAccessRestriction: 'HH_NEHRAR',
  nhgHealthBenefits: 'HEALTHBENE',
  notificationChildrenHealth: 'HH_NOTI_CH',
  notificationSchoolHealth: 'HH_NOTI_SH',
  onMyWay: 'OMW',
  payment: 'PAY',
  payments: 'HH_PAY_OUT',
  pharmacyQueue: 'HH_PHARMQ',
  prescriptionRecords: 'PSR',
  preventiveCare: 'PREVCARE',
  publicChatAssistant: 'HH_PUB_CA',
  publicMedicationRefill: 'HH_PUB_MRF',
  publicPayment: 'HH_PUB_PAY',
  publicScanQrCode: 'HH_PUB_SCANQR',
  questionnaires: 'QNS',
  radiologyReports: 'RDR',
  refunds: 'HH_REFUND',
  scanQrCode: 'SCANQR',
  schoolDentalRecords: 'HH_SCDR',
  schoolHealthPlan: 'HH_SCHP',
  settings: 'HH_SETTINGS',
  setupPaymentMethod: 'HH_PAY_METHOD',
  tcuAppointments: 'HH_APM_TCU',
  testReportsAndMc: 'TESTREP',
  trackMyHealth: 'TRKHEALTH',
  updateCaregiverDetail: 'HH_UPDATE_CG',
  updateChild: 'HH_UPDATE_CHILD',
  updateFamily: 'HH_UPDATE_FF',
  visitorRegistration: 'HH_VISREG',
} as const;
